import { Link } from 'react-router-dom';
import { Anchor, Card, CardBody, Page, PageContent, Paragraph } from 'grommet';

import ToggleableLeagueScoreboard from '../LeagueScoreboard/LeagueScoreboardToggle';
import PreseasonHome from '../home/PreseasonHome';
import { PRIMARY_LEAGUE_ID, CURRENT_SEASON } from '../config';
import { getPhase, getSeasonConfig } from '../seasons';

// The phase-aware homepage: one route, a different face per part of the
// calendar. Preseason gets the draft hub; in-season falls back to the
// scoreboard until the danger-board build lands (elimination weeks) and the
// playoff tracker after that.
export default function Dashboard() {
  const config = getSeasonConfig(CURRENT_SEASON);
  const phase = getPhase(config);

  if (phase === 'preseason') {
    return <PreseasonHome config={config} />;
  }

  return (
    <Page kind="narrow" pad="medium">
      <PageContent>
        <ToggleableLeagueScoreboard leagueId={PRIMARY_LEAGUE_ID} season={CURRENT_SEASON} />
        <Card flex={false}>
          <CardBody pad="medium">
            <Paragraph fill margin="none">
              Rules, format and past-season recaps live in the{' '}
              <Anchor as={Link} to="/docs">league docs</Anchor>.
            </Paragraph>
          </CardBody>
        </Card>
      </PageContent>
    </Page>
  );
}
